import { Locale } from 'modules/i18n';

export const requestsMapTranslation = {
  [Locale.en]: {
    title: 'Top 10 countries by requests',
  },
};
